import { Slide01Title } from './Slide01Title'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideValueCalculator } from './SlideValueCalculator'
import { SlideLoopModel } from './SlideLoopModel'
import { Slide02ExecSummary } from './Slide02ExecSummary'
import { Slide03Background } from './Slide03Background'
import { Slide04Approach } from './Slide04Approach'
import { Slide05Benefits } from './Slide05Benefits'
import { Slide06Timeline } from './Slide06Timeline'
import { Slide07Scope } from './Slide07Scope'
import { SlideCampaignCalendar } from './SlideCampaignCalendar'
import { Slide08Expansion } from './Slide08Expansion'
import { Slide09Metrics } from './Slide09Metrics'
import { Slide10Contacts } from './Slide10Contacts'
import { Slide11Actions } from './Slide11Actions'
import { Slide13Optimization } from './Slide13Optimization'
import { Slide14Channels } from './Slide14Channels'
import { Slide15Timeline } from './Slide15Timeline'
import { Slide16NextSteps } from './Slide16NextSteps'
import { Slide17Closing } from './Slide17Closing'

export const slides = [
  Slide01Title,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideValueCalculator,
  Slide02ExecSummary,
  Slide03Background,
  Slide04Approach,
  Slide05Benefits,
  SlideLoopModel,
  Slide13Optimization,
  Slide06Timeline,
  Slide07Scope,
  SlideCampaignCalendar,
  Slide14Channels,
  Slide08Expansion,
  Slide09Metrics,
  Slide10Contacts,
  Slide11Actions,
  Slide15Timeline,
  Slide16NextSteps,
  Slide17Closing,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'Established Brands Snakker Campaign Proposal' },
  { section: '02', title: 'Unlocking the Potential of the Tail' },
  { section: '03', title: 'As Familiarity Grows, Format Shortens' },
  { section: '04', title: 'The Value of a 1% Improvement' },
  { section: '05', title: 'Executive Summary' },
  { section: '06', title: 'Current Situation' },
  { section: '07', title: 'Strategic Opportunity' },
  { section: '08', title: 'Proposed Campaign Model' },
  { section: '09', title: 'A Loop, Not a Project' },
  { section: '10', title: 'Monitoring & Optimization' },
  { section: '11', title: 'What Is a Teaser?' },
  { section: '12', title: 'What Is a Trailer / Microsite?' },
  { section: '13', title: 'Campaign Calendar & Learning Loop' },
  { section: '14', title: 'Channel-Agnostic Deployment' },
  { section: '15', title: 'Asset Lifespan Recommendation' },
  { section: '16', title: '6-Month Proposal' },
  { section: '17', title: '12-Month Proposal' },
  { section: '18', title: 'Why 12 Months Is Recommended' },
  { section: '19', title: 'Timeline & Approvals' },
  { section: '20', title: 'Interactive Campaign Examples' },
  { section: '21', title: 'Closing Recommendation' },
]
